import { gql } from "@apollo/client";

/* ── AgreementType queries and mutations ───────────────────────────── */

export const AGREEMENT_TYPE_FIELDS = gql`
  fragment AgreementTypeFields on AgreementType {
    id
    tenantId
    typeKey
    name
    description
    sortOrder
    isActive
    createdAt
  }
`;

export const ALL_AGREEMENT_TYPES = gql`
  ${AGREEMENT_TYPE_FIELDS}
  query AllAgreementTypesForPortal(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: AgreementTypeFilter
  ) {
    allAgreementTypes(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      ...AgreementTypeFields
    }
  }
`;

export const ALL_AGREEMENT_TYPES_META = gql`
  query AllAgreementTypesMetaForPortal(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: AgreementTypeFilter
  ) {
    _allAgreementTypesMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;

export const GET_AGREEMENT_TYPE = gql`
  ${AGREEMENT_TYPE_FIELDS}
  query GetAgreementType($id: String!) {
    AgreementType(id: $id) {
      ...AgreementTypeFields
    }
  }
`;

export const CREATE_AGREEMENT_TYPE = gql`
  ${AGREEMENT_TYPE_FIELDS}
  mutation CreateAgreementTypeInPortal(
    $name: String!
    $typeKey: String!
    $description: String
    $sortOrder: Int
    $isActive: Boolean
  ) {
    createAgreementType(
      name: $name
      typeKey: $typeKey
      description: $description
      sortOrder: $sortOrder
      isActive: $isActive
    ) {
      ...AgreementTypeFields
    }
  }
`;

export const UPDATE_AGREEMENT_TYPE = gql`
  ${AGREEMENT_TYPE_FIELDS}
  mutation UpdateAgreementTypeInPortal(
    $id: String!
    $name: String
    $description: String
    $sortOrder: Int
    $isActive: Boolean
  ) {
    updateAgreementType(
      id: $id
      name: $name
      description: $description
      sortOrder: $sortOrder
      isActive: $isActive
    ) {
      ...AgreementTypeFields
    }
  }
`;

export const DELETE_AGREEMENT_TYPE = gql`
  ${AGREEMENT_TYPE_FIELDS}
  mutation DeleteAgreementTypeInPortal($id: String!) {
    deleteAgreementType(id: $id) {
      ...AgreementTypeFields
    }
  }
`;

/* ── TypeScript interface ──────────────────────────────────────────── */

export interface AgreementTypeRecord {
  id: string;
  tenantId: string;
  typeKey: string;
  name: string;
  description: string | null;
  sortOrder: number | null;
  isActive: boolean;
  createdAt: string;
}
